<template>
  <div id="page-paper-edit">
    {{ /* LOADER */ }}
    <loading
        :active.sync="loader.isLoading"
        :can-cancel="false"
        :is-full-page="loader.fullPage"
        :opacity="loader.opacity"
        :color="loader.color"
    ></loading>

    {{ /* Heading page */ }}
    <div class="header-pages-block d-md-flex justify-content-between">
      <div>
        <h5>
          {{ $t('pages.paper.editPaper') }}:
          <strong>{{ PaperModule.paper.name }}</strong>
        </h5>
      </div>
      <div>
        <router-link
            class="btn btn-outline-primary mb-3"
            :to="{ name: 'paper-index' }"
        >
          {{ $t('common.back') }}
        </router-link>
      </div>
    </div>

    {{ /* Form component */ }}
    <FormCrudPaper
        :paper="PaperModule.paper"
        :list-finishes="getListFinishes"
        :id="PaperModule.paper.id"
        :actionForm="'edit'"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      loader: {
        opacity: 0.9,
        isLoading: false,
        fullPage: true,
      }
    }
  },
  methods: {
    /*----------------- LOADER ------------------*/
    showLoader() {
      this.loader.isLoading = true
    },
    hideLoader() {
      this.loader.isLoading = false
    },
  },
  created() {
    this.showLoader()

    this.$store.dispatch('fetchPaper', this.$route.params.id)
  },
  updated() {
    this.hideLoader()
  },
  computed: {/**
     * Create list id of finishes
     * @returns {[]}
     */
    getListFinishes() {
      let finishesId = []

      if(this.PaperModule.paper.finishes) {
        this.PaperModule.paper.finishes.forEach(function(paper) {
          finishesId.push(paper.id)
        })
      }

      return finishesId
    },
    ...mapState(['PaperModule'])
  },
  components: {
    Loading: () => import('vue-loading-overlay'),
    FormCrudPaper: () => import('@/components/pages/paper/FormCrudPaper')
  }
}
</script>

<style scoped>

</style>
